import React, { useEffect, useState } from "react";
import { Row, Col, Select, Button, message } from "antd";
import { getColumnFromSuite } from "../../../service/suite.service";
import TaskMapFields from "./TaskMapFields";
import { CheckOutlined, ArrowLeftOutlined } from "@ant-design/icons";

const { Option } = Select;
function DbToDbTask(props) {
  const [testSuiteIdOne, setTestSuiteIdOne] = useState("");
  const [testSuiteIdTwo, setTestSuiteIdTwo] = useState("");
  const [isGreen, setIsGreen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [sqlHeaderOne, setSqlHeaderOne] = useState([]);
  const [sqlHeaderTwo, setSqlHeaderTwo] = useState([]);
  const [mappingSelection, setMappingSelection] = useState([]);

  // Swap the modal body in-place when the mapping editor opens (no nested modal).
  useEffect(() => {
    props.onMapViewChange?.(isOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const onChangeTestSuiteOne = (key, value) => {
    setTestSuiteIdOne(value.value);
    getSuiteHeaderOne(value.value);
  };
  const onChangeTestSuiteTwo = (key, value) => {
    setTestSuiteIdTwo(value.value);
    getSuiteHeaderTwo(value.value);
  };

  const getSuiteHeaderOne = (testSuiteId) => {
    getColumnFromSuite(testSuiteId, "Field Level").then((res) => {
      if (res.status === 200) {
        setSqlHeaderOne(res.data);
      }
    });
  };
  const getSuiteHeaderTwo = (testSuiteId) => {
    getColumnFromSuite(testSuiteId, "Field Level").then((res) => {
      if (res.status === 200) {
        setSqlHeaderTwo(res.data);
      }
    });
  };
  const handleModal = () => {
    setIsOpen(!isOpen);
  };
  const onMappingClick = () => {
    if (!testSuiteIdOne || !testSuiteIdTwo) {
      message.error("Select both test suites before you can map fields.");
    } else {
      handleModal();
    }
  };
  const mappingConfirmed = (key, tableData, mappingName, fieldTests, type) => {
    const hasData = tableData && tableData.length > 0;
    setIsGreen(hasData);
    props.setMappedData(hasData ? tableData : []);
    props.setMapName(mappingName || "");
    props.setMappingSelection(type === "new" ? "new" : "existing");
    props.saveDbToDbData(
      tableData,
      mappingName,
      testSuiteIdOne,
      testSuiteIdTwo,
      type,
    );
    setIsOpen(false);
  };

  // Fields are HIDDEN (not unmounted) while the mapping editor is open so the
  // uncontrolled inputs and loaded suite-header state survive the round-trip.
  return (
    <>
      {isOpen && (
        <div className="tm-map-view">
          <button type="button" className="tm-back" onClick={handleModal}>
            <ArrowLeftOutlined /> Back to task
          </button>
          <p className="modal-header-text tm-map-title">Map Fields</p>
          <TaskMapFields
            sqlHeader={sqlHeaderTwo}
            fileHeader={sqlHeaderOne}
            clickPrevious={handleModal}
            confirmMapFields={mappingConfirmed}
            mappingSelection={props.mappingSelection}
            setMappingSelection={props.setMappingSelection}
            mapName={props.mapName}
            setMapName={props.setMapName}
            mappedData={props.mappedData}
            setMappedData={props.setMappedData}
            setMappedList={props.setMappedList}
            mappedList={props.mappedList}
          />
        </div>
      )}
    <div style={{ display: isOpen ? "none" : undefined }}>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">First Test Suite *</p>
        </Col>
        <Col span={18}>
          <Select
            style={{ width: "100%" }}
            placeholder="select first test suite"
            showSearch
            onChange={onChangeTestSuiteOne}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {props.testSuites.map((item) => (
              <Option
                key={item.testSuiteName}
                value={item.testSuiteId}
                spec={item.controlDocumentName}
              >
                {item.testSuiteName}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Second Test Suite *</p>
        </Col>
        <Col span={18}>
          <Select
            style={{ width: "100%" }}
            placeholder="select second test suite"
            showSearch
            onChange={onChangeTestSuiteTwo}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {props.testSuites.map((item) => (
              <Option
                key={item.testSuiteName}
                value={item.testSuiteId}
                spec={item.controlDocumentName}
              >
                {item.testSuiteName}
              </Option>
            ))}
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <p className="spec-modal-label">Mapping Details *</p>
        </Col>
        <Col span={18}>
          <Button
            icon={
              isGreen && (
                <CheckOutlined
                  style={{ color: isGreen ? "green" : "default" }}
                />
              )
            }
            type="dashed"
            onClick={onMappingClick}
            style={{
              borderColor: isGreen ? "green" : "default",
              borderStyle: "dashed",
            }}
          >
            Click here to edit/view mapping
          </Button>
        </Col>
      </Row>
    </div>
    </>
  );
}

export default DbToDbTask;
